import { useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { useClienteLogado, useSessao } from '../../redux/sessao/sessaoHooks';
import Container from '../../Components/generic/Container';
import CardsPedido from './CardsPedido';
import CardDebitosEmAberto from './CardDebitosEmAberto';

const InicioPage: React.FC = () => {
  const clienteLogado = useClienteLogado();

  const [sessao] = useSessao();
  const [loading] = useState(false);

  const nomeCliente = clienteLogado?.nome?.trim() ?? '';

  const nomeClienteFormatado = nomeCliente
    .toLowerCase()
    .split(' ')
    .filter(Boolean)
    .map((palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1))
    .join(' ');

  const clientePodeFazerPedido = sessao?.empresa?.clientePodeFazerPedido;

  return (
    <Container page elevation={2} loading={loading}>
      <Grid container sx={{ marginTop: { xs: '0', md: '0' } }}>
        {nomeClienteFormatado?.trim()?.length > 0 && (
          <Grid item xs={12} style={{ marginBottom: '5px' }}>
            <Typography fontSize={25}>Olá, {nomeClienteFormatado}</Typography>
            <Typography variant="subtitle1" color="text.secondary">
              {new Date().toLocaleDateString('pt-BR', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </Typography>
          </Grid>
        )}

        {clientePodeFazerPedido && <CardsPedido />}

        <CardDebitosEmAberto />
      </Grid>
    </Container>
  );
};

export default InicioPage;
